/* eslint-disable */

import * as clientService from "./httpsClient";

export const getDestinationDelivery = async (accessToken, params) => {
  try {
    const domain = `destinationdelivery`;
    return await clientService.getApi(domain, accessToken, params);
  } catch (error) {
    throw error;
  }
};

export const getDestinationDeliveryById = async (accessToken, id, params) => {
  try {
    const domain = `destinationdelivery/${id}`;
    return await clientService.getApi(domain, accessToken, params);
  } catch (error) {
    throw error;
  }
};

export const createDestinationDelivery = async (accessToken, body) => {
  try {
    const domain = `destinationdelivery`;
    return await clientService.postApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const updateDestinationDelivery = async (accessToken, body) => {
  try {
    const domain = `destinationdelivery`;
    return await clientService.putApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const deleteDestinationDelivery = async (accessToken, body) => {
  try {
    const domain = `destinationdelivery`;
    return await clientService.deleteApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const getDestinationDeliveryPackage = async (accessToken, params) => {
  const { page, limit, values } = params;
  let object = {
    page: page ? page : 0,
    limit: limit ? limit : 10,
    id: values ? values : undefined,
  };
  try {
    const domain = `destinationdelivery/get/destinationdeliverypackage`;
    return await clientService.getApi(domain, accessToken, object);
  } catch (error) {
    throw error;
  }
};

export const getDestinationPackageForCreate = async (accessToken, params) => {
  try {
    const domain = `destinationpackage/listdestinationpackage`;
    return await clientService.getApi(domain, accessToken, params);
  } catch (error) {
    throw error;
  }
};

export const createDestinationDeliveryPackage = async (accessToken, body) => {
  try {
    const domain = `destinationdelivery/create/destinationdeliverypackage`;
    return await clientService.postApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const updateDestinationDeliveryPackage = async (accessToken, body) => {
  try {
    const domain = `destinationdelivery/update/destinationdeliverypackage`;
    return await clientService.putApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const deleteDestinationDeliveryPackage = async (accessToken, body) => {
  try {
    const domain = `destinationdelivery/delete/destinationdeliverypackage`;
    return await clientService.deleteApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const exportExcelZip = async (accessToken, params) => {
  try {
    const domain = `destinationdelivery/export-excel`;
    return await clientService.exportExcelZip(domain, accessToken, params);
  } catch (error) {
    throw error;
  }
};

export const deleteMultiDestinationDeliveryPackage = async (accessToken, body) => {
  try {
    const domain = `destinationdelivery/delete-all`;
    return await clientService.postApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};
